
document.addEventListener('DOMContentLoaded', function(e) {
  window.onscroll = function() {
    var offset = window.pageYOffset;
    if (offset > 0) {
      document.body.classList.add('sticky');
    } else {
      document.body.classList.remove('sticky');
    }
  };

});
